import { useState } from 'react';

const useAttendanceTile = () => {
  const [isAttendanceDrawerOpen, setIsAttendanceDrawerOpen] = useState(false);

  const handleCloseAttendanceDrawer = () => {
    setIsAttendanceDrawerOpen(false);
  };

  const handleClick = () => {
    setIsAttendanceDrawerOpen(true);
  };

  return { isAttendanceDrawerOpen, handleCloseAttendanceDrawer, handleClick };
};

export default useAttendanceTile;
